import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";

const GET_POPULAR_KEYWORD = gql`
  query GetPopularKeywords {
    getPopularKeywordsByFilterCached {
      popularKeywords {
        text
      }
    }
  }
`;

/**
 * 인기 키워드 정보 가져오기
 */
export const usePopularKeywords = () => {
  const { loading, error, data } = useQuery(GET_POPULAR_KEYWORD);

  return { loading, error, data };
};
